/**
 * A caixa "Mês de referência" com as setas ‹ ›.
 *
 * Papel: reproduz a caixa da direita do cabeçalho do Fechamento (l. 581–588) —
 * fundo branco, borda bege com a de cima em latão de 3 px, rótulo em mono
 * 10 px, os dois botões de 28 × 28 na fonte do navegador e o mês em Outfit
 * 19 px 300 com 120 px mínimos.
 *
 * Como usar: quem monta passa o rótulo já escrito (`rotuloDoMes`) e os dois
 * manipuladores, que mudam o mês aberto da página; a caixa não guarda estado.
 * As setas não têm texto além de "‹" e "›", e o nome acessível delas é "Mês de
 * referência anterior" e "Próximo mês de referência", para não se confundirem
 * com os atalhos "Mês anterior" e "Próximo mês" da aba Lançamentos.
 */

interface NavegacaoDoMesProps {
  /** O mês aberto, como `MAR 2026`. */
  rotulo: string;
  onAnterior: () => void;
  onProximo: () => void;
}

/** O botão ‹ ou ›, na fonte que o navegador dá a todo botão sem `font-family`. */
const CLASSE_DA_SETA =
  '[font-family:revert] border-emb-borda flex h-7 w-7 cursor-pointer items-center justify-center rounded-[6px] border bg-transparent text-[18px] leading-none text-foreground transition-all duration-150 hover:bg-background';

/**
 * A caixa do mês de referência.
 *
 * @param rotulo - O mês aberto, já escrito.
 * @param onAnterior - Chamado pela seta ‹.
 * @param onProximo - Chamado pela seta ›.
 * @returns A caixa.
 */
export function NavegacaoDoMes({ rotulo, onAnterior, onProximo }: NavegacaoDoMesProps) {
  return (
    <div className="rounded-emb border border-t-[3px] border-emb-borda border-t-brass bg-superficie px-[18px] py-3 text-center">
      <div className="mb-2 font-mono text-[10px] tracking-[0.7px] text-texto-fraco uppercase">
        Mês de referência
      </div>
      <div className="flex items-center justify-center gap-2.5">
        <button
          type="button"
          aria-label="Mês de referência anterior"
          onClick={onAnterior}
          className={CLASSE_DA_SETA}
        >
          ‹
        </button>
        <span className="min-w-[120px] text-center font-outfit text-[19px] font-light tracking-[0.5px] whitespace-nowrap text-foreground">
          {rotulo}
        </span>
        <button
          type="button"
          aria-label="Próximo mês de referência"
          onClick={onProximo}
          className={CLASSE_DA_SETA}
        >
          ›
        </button>
      </div>
    </div>
  );
}
